import { render, staticRenderFns } from "./swpAttach.vue?vue&type=template&id=db72e8c2"
import script from "./swpAttach.vue?vue&type=script&lang=js"
export * from "./swpAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db72e8c2')) {
      api.createRecord('db72e8c2', component.options)
    } else {
      api.reload('db72e8c2', component.options)
    }
    module.hot.accept("./swpAttach.vue?vue&type=template&id=db72e8c2", function () {
      api.rerender('db72e8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpAttach.vue"
export default component.exports